// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"292":"dc6a055a","311":"5ffe1889"}[chunkId] + "." + {"292":"a40bd42de09789b1","311":"f2361039d73b3e5c"}[chunkId] + ".js";
};